// uploadSkitStepPage.jsx
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation} from "react-router-dom";
import { useAuth } from "../../components/context/authContext.jsx";
import { FORM_FLOW_CONTROL } from "../../constants/currentContextTypes.js";
import Television from "../../components/television/television.jsx";
import UploadVideoForm from "../../components/forms/uploadVideoForm.jsx";

const UploadSkitStepPage = () => {
  const navigate = useNavigate();
  const {
    verifyNeeded,
    setVerifyNeeded,
    setCurrentContextType,
    setCurrentFormStep,
    currentMemberId,
    currentMemberData, // ⬅️ pull this so we can log/verify
    setCurrentMemberData, // ⬅️ optional: seed if you have cached user JSON
  } = useAuth();
  const location = useLocation();
  const origin = location.state?.from ?? "/skitslist";
  const returnState = location.state?.fromState ?? null;
  const [isUploadVideoFormOpen, setIsUploadVideoFormOpen] = useState(false);
  const startedRef = useRef(false);

  // Enter the gate on first render
  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    console.log("[UploadSkit] mount → enter gate");
    setVerifyNeeded(true);
    setCurrentContextType(
      FORM_FLOW_CONTROL.MEMBER_SOURCE_SKIT_UPLOAD_PERMISSIONS
    );
  }, []);

  const openUploader = useCallback(() => {
    console.log("[UploadSkit] openUploader → show UploadVideoForm");
    setIsUploadVideoFormOpen(true);
    setCurrentContextType("uploadSkit"); // optional tag
  }, [setCurrentContextType]);

  const onVerified = useCallback(() => {
    console.log("[UploadSkit] onVerified → baseline + open uploader");
    setVerifyNeeded(false);
    setCurrentContextType(FORM_FLOW_CONTROL.SIGN_IN_FORM);
    setCurrentFormStep(FORM_FLOW_CONTROL.SIGN_IN_FORM);
    openUploader();
  }, [
    setVerifyNeeded,
    setCurrentContextType,
    setCurrentFormStep,
    openUploader,
  ]);

  const onCancelled = useCallback(() => {
    console.log("[UploadSkit] onCancelled → baseline + back");
    setVerifyNeeded(false);
    setCurrentContextType(FORM_FLOW_CONTROL.SIGN_IN_FORM);
    setCurrentFormStep(FORM_FLOW_CONTROL.SIGN_IN_FORM);
    navigate(-1);
  }, [setVerifyNeeded, setCurrentContextType, setCurrentFormStep, navigate]);

  const onServerSuccess = useCallback(() => {
    setIsUploadVideoFormOpen(false);
    navigate(origin, {
      replace: true,
      state: { ...(returnState || {}), refreshFromUpload: true }, // includes activeChannelId
    });
  }, [origin, returnState, navigate, setIsUploadVideoFormOpen]);
  
  const handleUploadCancel = useCallback(() => {
    setIsUploadVideoFormOpen(false);
    navigate(origin, { replace: true, state: returnState });       // includes activeChannelId
  }, [origin, returnState, navigate, setIsUploadVideoFormOpen]);

  console.log("[UploadSkit] render", {
    verifyNeeded,
    isUploadVideoFormOpen,
    currentContextTypeFromPage: "memberSourceSkitUploadPermissions?",
    currentMemberId,
    hasPhone: !!currentMemberData?.phoneNumber,
  });

  return (
    <>
      {verifyNeeded && (
        <Television
          onVerified={onVerified}
          onCancelled={onCancelled}
          shouldTvText={false}
        />
      )}

      {isUploadVideoFormOpen && !verifyNeeded && (
        <UploadVideoForm
          isUploadVideoFormOpen={isUploadVideoFormOpen}
          currentMemberId={currentMemberId}
          closeModal={handleUploadCancel}
          onServerSuccess={onServerSuccess}
        />
      )}
    </>
  );
};

export default UploadSkitStepPage;
